export enum EmailInboxType {
  Inbox = 1,
  Archived = 2,
}
